import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from "common/hook";
import {accountUserActions} from "app/accountLoginSlice";
import {USER_SUCCESS_KEY} from "shared/const/localstorage";
import {Preloader} from "../layout/preloader/Preloader";

interface AuthWrapperProps {
    children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const isLogin = useAppSelector((state) => state.accountUser.isLogin);
    const isLoading = useAppSelector((state) => state.accountUser.isLoading);

    useEffect(() => {
        const isUserLoggedIn = JSON.parse(localStorage.getItem(USER_SUCCESS_KEY) || 'false');

        // Устанавливаем isLoading в true перед началом загрузки данных
        dispatch(accountUserActions.setLoading(true));

        // Выполняем асинхронную операцию и завершаем ее до установки isLoading в false
        async function fetchData() {
            try {
                dispatch(accountUserActions.accountUser(isUserLoggedIn));
            } catch (error) {

            } finally {
                dispatch(accountUserActions.setLoading(false));
            }
        }
        fetchData();
    }, [dispatch]);



    if (isLoading) {
        return <Preloader />;
    }

    if (!isLogin) {
        navigate("/");
    }

    return <>{children}</>;
};

export default AuthWrapper;
